// extracted by mini-css-extract-plugin
export default {"Friends":"friends_Friends__IQx8h","Entries":"friends_Entries__vrL1l","Entry":"friends_Entry__4-gfM","Links":"friends_Links__iciJh"};